export default {
  styleOverrides: {
    root: {},
    elevation1: {
      boxShadow: 'none'
    }
  }
};
